/**
 * Skeleton — единый лоадер-плейсхолдер приложения.
 *
 * Зачем: раньше каждый экран решал сам — кто-то показывал спиннер, кто-то
 * пустоту. На главной лоадер вообще прятался ДО загрузки, и пока грузился
 * каталог (сотни стилей одним ответом), юзер смотрел на пустой экран.
 *
 * Два правила тайминга (иначе лоадер сам портит ощущение скорости):
 *   • DELAY 250мс — если данные пришли быстро, скелетон вообще не
 *     показываем. Вспышка плейсхолдера хуже, чем ничего.
 *   • MIN_VISIBLE 400мс — если уже показали, держим минимум. Иначе
 *     мгновенное исчезновение читается как глитч.
 *
 * Плейсхолдер — элемент той же плитки (webapp/css/masonry.css), что и
 * карточки: те же колонки, строки подписи и отступ листинга, кадр
 * .masonry-frame. Какой пропорции будут настоящие кадры, до ответа не
 * знает никто, поэтому скелетон чередует типичные форматы каталога
 * (SHAPES) — плитка с первого кадра выглядит плиткой, а не ровной
 * сеткой 3:4, которая при подмене «рассыпалась» бы в masonry.
 *
 * Строитель card() — один на все скелетоны ленты: Skeleton.show (фетч
 * каталога), boot-скелетон index.html (до defer-бандла, поэтому этот
 * файл и lib/masonry.js подключены в <head> синхронно) и заглушки
 * шторки поиска (feed-search.js).
 */
window.Skeleton = (function () {
    'use strict';

    const DELAY_MS = 250;
    const MIN_VISIBLE_MS = 400;
    const SK_CLASS = 'skeleton-card';
    const SK_WRAP_CLASS = 'skeleton-card-wrap';
    // Типичные форматы каталога, по кругу: портрет 3:4 и 2:3, 4:5 из
    // соцсетей, вертикальное видео 9:16. Порядок фиксирован — плитка
    // скелетона одинакова от запуска к запуску, без мерцания случайностью.
    const SHAPES = ['3:4', '2:3', '4:5', '9:16', '4:5', '3:4'];

    /**
     * Один плейсхолдер плитки: обёртка .masonry-item + кадр
     * .skeleton-card.masonry-frame. Пропорция — из `item` (если данные
     * карточки уже есть, например bootstrap до бандла), иначе формат
     * SHAPES по индексу.
     *
     * NB: обёртке НЕ даём класс .style-card-container. Он бы затащил
     * stagger-анимацию из references.css (`opacity: 0` + fadeInUp с
     * задержкой до 0.45с) — лоадер, который сам проявляется полсекунды,
     * бессмыслен.
     */
    function card(index, item) {
        const wrap = document.createElement('div');
        wrap.className = SK_WRAP_CLASS + ' masonry-item';
        // Декор — из дерева доступности убираем, озвучивает контейнер.
        wrap.setAttribute('aria-hidden', 'true');
        window.Masonry.apply(wrap, item || { aspect_ratio: SHAPES[index % SHAPES.length] });
        const frame = document.createElement('div');
        frame.className = SK_CLASS + ' masonry-frame';
        wrap.appendChild(frame);
        return wrap;
    }

    /** Вставляет `count` плейсхолдеров в контейнер-плитку. */
    function show(container, count) {
        if (!container) return;
        const n = Math.max(1, count || 6);
        const frag = document.createDocumentFragment();
        for (let i = 0; i < n; i++) frag.appendChild(card(i));
        container.appendChild(frag);
        container.setAttribute('aria-busy', 'true');
        // role/aria-live ставим на контейнер один раз — диктор объявит
        // «загрузка», а потом результат, без спама на каждый плейсхолдер.
        if (!container.hasAttribute('role')) {
            container.setAttribute('role', 'status');
            container.setAttribute('aria-live', 'polite');
        }
    }

    /** Убирает плейсхолдеры (реальные карточки не трогает). */
    function hide(container) {
        if (!container) return;
        container.querySelectorAll('.' + SK_WRAP_CLASS).forEach((n) => n.remove());
        container.setAttribute('aria-busy', 'false');
    }

    /**
     * Обёртка вокруг загрузки: сама решает, показывать ли скелетон,
     * и держит его минимальное время.
     *
     *   await Skeleton.around(container, fetchAndRender(), { count: 8 });
     */
    async function around(container, promise, options) {
        const opts = options || {};
        const count = opts.count || 6;
        const delay = opts.delay != null ? opts.delay : DELAY_MS;
        const minVisible = opts.min != null ? opts.min : MIN_VISIBLE_MS;

        let shown = false;
        let shownAt = 0;
        const timer = setTimeout(() => {
            shown = true;
            shownAt = Date.now();
            show(container, count);
        }, delay);

        try {
            return await promise;
        } finally {
            clearTimeout(timer);
            if (shown) {
                const rest = minVisible - (Date.now() - shownAt);
                if (rest > 0) await new Promise((r) => setTimeout(r, rest));
                hide(container);
            } else {
                // Скелетон не показывали — но aria-busy мог остаться
                // от прошлого цикла загрузки.
                if (container) container.setAttribute('aria-busy', 'false');
            }
        }
    }

    return { card, show, hide, around };
})();
